import React from 'react';
import './CentralDeAtendimento.css';

export const Section: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => (
	<section className={`central-container ${className || ''}`}>
		{children}
	</section>
);

export const Grid: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => (
	<div className={`central-grid ${className || ''}`}>
		{children}
	</div>
);

export const Heading: React.FC<{ level: 1 | 2 | 3; children: React.ReactNode }> = ({ level, children }) => {
	const Tag = `h${level}` as keyof JSX.IntrinsicElements;
	return <Tag className="heading">{children}</Tag>;
};

export const Paragraph: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<p className="paragraph">{children}</p>
);

export const Button: React.FC<{ href: string; label: string }> = ({ href, label }) => (
	<a
		href={href}
		className="central-update-button"
		target="_blank"
		rel="noopener noreferrer"
	>
		{label}
	</a>
);

export const ImageWithDecor: React.FC<{ src: string; alt: string }> = ({ src, alt }) => (
	<div className="central-image-area">
		<img src={src} alt={alt} />
	</div>
);

export const ImageArea: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<div className="central-column--image">
		{children}
	</div>
);

export const ContentArea: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<div className="central-column--content">
		{children}
	</div>
);
